/**
 * Loading component that displays a spinning animation
 * If user is logged in, it also shows the header and navigation
 */
export function LoadingComponent() {
    return (
        <div className="flex flex-col items-center justify-center h-full mx-auto">
            <div className="w-32 h-32 mx-auto my-auto border-t-2 border-b-2 border-gray-900 rounded-full animate-spin" />
        </div>
    )
}   